module.exports = __webpack_public_path__ + "static/img/20200810.b14be5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/entry/20200810.png
// module id = iImR
// module chunks = 0